export const initialState = {
  tutoringList: [],
  nextToken: null,
  nextTokens: { 1: null },
  tutoringListLoading: false,
  tutoringListError: null,
  newTutoring: {},
  newTutoringLoading: false,
  newTutoringError: null,
  tutoring: {},
  tutoringLoading: false,
  tutoringError: null,
  updateTutoring: {},
  updateTutoringLoading: false,
  updateTutoringError: null,
  schedules: [],
  schedulesLoading: false,
  schedulesError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_LIST_TUTORING_PROGRAM":
      return {
        ...state,
        tutoringList: [],
        nextToken: null,
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        tutoringListError: null,
        tutoringListLoading: true,
      };
    case "LIST_TUTORING_PROGRAM_SUCCESS":
      return {
        ...state,
        tutoringList: action.payload.items,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        tutoringListLoading: false,
      };
    case "LIST_TUTORING_PROGRAM_ERROR":
      return {
        ...state,
        tutoringListLoading: false,
        tutoringListError: action.error,
      };
    case "REQUEST_CREATE_TUTORING_PROGRAM":
      return {
        ...state,
        newTutoring: {},
        request: action.payload.request,
        newTutoringLoading: true,
        newTutoringError: null,
      };
    case "CREATE_TUTORING_PROGRAM_SUCCESS":
      return {
        ...state,
        newTutoring: action.payload.newTutoring,
        newTutoringLoading: false,
        request: null,
      };
    case "CREATE_TUTORING_PROGRAM_ERROR":
      return {
        ...state,
        newTutoringLoading: false,
        newTutoringError: action.error,
        request: null,
      };
    case "REQUEST_GET_TUTORING_PROGRAM":
      return {
        ...state,
        tutoring: {},
        tutoringError: null,
        tutoringLoading: true,
      };
    case "GET_TUTORING_PROGRAM_SUCCESS":
      return {
        ...state,
        tutoring: action.payload.item,
        tutoringLoading: false,
      };
    case "GET_TUTORING_PROGRAM_ERROR":
      return {
        ...state,
        tutoringLoading: false,
        tutoringError: action.error,
      };
    case "REQUEST_LIST_TUTORING_SCHEDULE":
      return {
        ...state,
        schedules: [],
        schedulesError: null,
        schedulesLoading: true,
      };
    case "LIST_TUTORING_SCHEDULE_SUCCESS":
      return {
        ...state,
        schedules: action.payload.items,
        schedulesLoading: false,
      };
    case "LIST_TUTORING_SCHEDULE_ERROR":
      return {
        ...state,
        schedulesLoading: false,
        schedulesError: action.error,
      };
    case "REQUEST_UPDATE_TUTORING_PROGRAM":
      return {
        ...state,
        updateTutoring: {},
        request: action.payload.request,
        updateTutoringLoading: true,
        updateTutoringError: null,
      };
    case "UPDATE_TUTORING_PROGRAM_SUCCESS":
      return {
        ...state,
        updateTutoring: action.payload.updateTutoring,
        updateTutoringLoading: false,
        request: null,
      };
    case "UPDATE_TUTORING_PROGRAM_ERROR":
      return {
        ...state,
        updateTutoringLoading: false,
        updateTutoringError: action.error,
        request: null,
      };
    case "RESET_TUTORING_PROGRAM":
      return {
        ...state,
        newTutoring: {},
        tutoring: {},
        tutoringError: null,
        newTutoringError: null,
        updateTutoring: {},
        updateTutoringError: null,
      };
    default:
      return state;
  }
};
